<template>
  <div class="group-setup">
    <v-progress-linear
      indeterminate
      color="orange"
      v-if="loading"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card class="pa-5">
      <v-card-title dark>
        <h3 class="ma-2">Monthly Meeting</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-form>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-text-field
              outlined
              dense
              v-model="form.venue"
              label="Venue*"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <DatePicker
              :lable="'Date*'"
              v-model="form.date"
              :setectVale="form.date"
              @changeInput="form.date = $event"
            ></DatePicker>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-text-field
              outlined
              dense
              v-model="form.no_of_attendance"
              label=" No. of Club Member Attendance *"
              type="number"
              :rules="[v => !!v || 'Required', v => v <= clubMemberCount || 'Cannot exceed ' + clubMemberCount + ' active members']"
              required
            ></v-text-field>
            <small class="grey--text">Max: {{ clubMemberCount }} active members</small>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-text-field
              outlined
              dense
              v-model="form.no_of_lion_ladies"
              label="No of Lion Ladies"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-text-field
              outlined
              dense
              v-model="form.no_of_leos"
              label="Number of Leos"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-text-field
              outlined
              dense
              v-model="form.others"
              label="Number of Other Guests"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" sm="12">           
            <v-select
              v-model="form.special_event"
              :items="specialEvents"             
              label="Special Event"
              dense
              outlined             
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document1"
              prepend-icon="mdi-paperclip"
              label="Please upload photo 01"
            ></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document2"
              prepend-icon="mdi-paperclip"
              label="Please upload photo 02"
            ></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document3"
              prepend-icon="mdi-paperclip"
              label="Please upload photo 03"
            ></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document4"
              prepend-icon="mdi-paperclip"
              label="Please upload photo 04"
            ></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document5"
              prepend-icon="mdi-paperclip"
              label="Please upload attendance sheet"
            ></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document6"
              prepend-icon="mdi-paperclip"
              label="Please upload agenda"
            ></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
        </v-row>
         <v-row>
          <v-col cols="12" md="12" sm="12">
            <v-label>Select Attended members</v-label>
          <AutocompleteAvatar
            @changeData="changeMembers($event)"  
              :storeLink="'member/getClubMembersBySearch'"             
              :setectVale="form.members"
              :itemText="'name'"
          ></AutocompleteAvatar>
          </v-col>
        </v-row>
      </v-form>
      <v-divider></v-divider>
      <v-card-actions v-if="!cpRole">
        <v-row>
          <v-col cols="12" md="9" xs="6"></v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn
              large
              color="success"
              depressed
              :disabled="loading || !form.venue"
              block
              @click="submit()"
              >Submit to Review</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import DatePicker from "@/components/shared/DatePicker";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import { ActivityService } from "../../../services/activity-service.js";
import { MemberService } from "../../../services/member-service.js";
import { checkError } from "@/config/errors.js";


import AutocompleteAvatar from "@/components/shared/AutocompleteAvatar";

export default {
  name: "groupSetUpFrom",

  components: { Alert, Snackbars, DatePicker, AutocompleteAvatar },

  data: () => ({
    cpRole: false,
    loading: false,
    errors: null,
    snackbar: false,
    successMsg: "",
    clubMemberCount: 0,
    form: {
      venue: "",
      date: "",
      no_of_members: "",
      no_of_attendance: "",
      others: "",
      no_of_lion_ladies: "",
      no_of_leos: "",
      special_event: "",
      document1: null,
      document2: null,
      document3: null,
      document4: null,
      document5: null,
      document6: null,
      members:[]
    },
    specialEvents:[
      'Installation of Club office Bearers',
      'Honoring of Past Presidents',
      'Honoring of Lion Ladies',
      'Zone Chairman Visit',
      'Region Chairman Visit',
      '1st VDG Visit',
      '2nd VDG Visit',
      'Founders Month/ Honoring of MJFS',
      'Honoring of Past District Governors',
      'District Governors Visit',
      'CQI Program',
      'New Member Installation',
      "Outside Senior Lion appreciation",
      'Other Events',
    ],
    url:'month_meeting',
  }),

  mounted() {
    this.fetchClubMemberCount();
  },

  computed: {
    ...mapGetters({
      member: "profile",
    }),
  },

  methods: {
    fetchClubMemberCount() {
      const profile = this.member;
      const clubId = profile && profile.club && profile.club.uuid ? profile.club.uuid : null;
      if (clubId) {
        MemberService.getClubMemberCount(clubId)
          .then((response) => {
            this.clubMemberCount = parseInt(response.data) || 0;
          })
          .catch(() => {
            this.clubMemberCount = 0;
          });
      }
    },
    submit() {
      this.errors = null;
      this.loading = true;
      this.snackbar = false;
      let fd = new FormData();
      fd.append("document1", this.form.document1);
      fd.append("document2", this.form.document2);
      fd.append("document3", this.form.document3);
      fd.append("document4", this.form.document4);
      fd.append("document5", this.form.document5);
      fd.append("document6", this.form.document6);
      fd.append("venue",this.form.venue);
      fd.append("no_of_members",this.form.no_of_attendance);
      fd.append("no_of_attendance",this.form.no_of_attendance);
      fd.append("date",this.form.date);
      fd.append("no_of_lion_ladies",this.form.no_of_lion_ladies);
      fd.append("no_of_leos", this.form.no_of_leos);
      fd.append("others", this.form.others);
      fd.append("special_event",this.form.special_event);
      fd.append("month", this.$route.params.month);
      fd.append("key", "MONTHLY_MEETING");

      this.form.members.forEach((member, key) => {
          fd.append("members["+key+"]", member);
      });

      let data = fd;
      ActivityService.submitActivity(this.url, data)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {           
            this.$router.push("/activities/monthly"); 
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },   

    onDismissed() {
      this.errors = null;
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    reset() {
      this.form.name = "";
    },
    changeMembers(value){     
      this.form.members = value;
    },
  },
};
</script>
